import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const Component = () => {
  return (
    <Box
      sx={{ py: 7.5, minHeight: 'min(50vh, 30rem)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      className="container-fluid"
    >
      <CircularProgress size="7.5rem" />
    </Box>
  );
};
export const PageSpinner = React.memo(Component);
